import { render, staticRenderFns } from "./comp_modal_conflict_filters.vue?vue&type=template&id=420b2672&"
import script from "./comp_modal_conflict_filters.vue?vue&type=script&lang=js&"
export * from "./comp_modal_conflict_filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports